module.exports = __webpack_public_path__ + "assets/images/pages/hearthy/icon-hearthy-2.png?9b3e61b4";